<ng-container *transloco="let t; prefix: 'dod-open-directory-btn'">
  @if (!isMobile()) {
    <a
      data-cy="btn-open-directory"
      accredible-button-outline
      icon="external"
      iconSize="12px"
      [href]="directoryUrl()"
      target="_blank"
      [attr.disabled]="disabled()">
      {{ t('open_directory') }}
    </a>
  } @else {
    <a
      data-cy="btn-open-directory"
      accredible-button-flat
      icon="external"
      iconSize="12px"
      [href]="directoryUrl()"
      target="_blank"
      [attr.disabled]="disabled()">
      {{ t('open_directory') }}
    </a>
  }
</ng-container>
